import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

import {
  FaHome,
  FaUser,
  FaIdCard,
  FaCreditCard,
  FaAddressCard,
  FaClipboardCheck,
  FaDownload,
  FaBell,
  FaHeadset,
  FaUsers,
  FaSignOutAlt,

} from "react-icons/fa";

import "./MemberLayout.css";
import logo from "../../assets/images/Logo.jpeg";

function MemberLayout() {
  const [sidebarCollapsed, ] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    // No authentication/session contract was supplied. Do not clear storage
    // or pretend to log out; route to the login page if your app has one.
    navigate("/login");
  };

  return (
    <div className={`member-layout ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <header className="member-header">
        <div className="member-brand">
          <div className="member-logo">
            <img
              src={logo}
              alt="ABNB Seva Samithi and Vidya Charitable Trust emblem"
            />
          </div>

          <div className="member-brand-text">
            <h1>ABNB SEVA SAMITI</h1>
            <h2>&amp; VIDYA CHARITABLE TRUST</h2>
            <p>Serve The Community. Secure The Future.</p>
          </div>
        </div>

        

        <div className="header-right">
          

          <div className="header-divider" />

          <div className="member-welcome">
            <div className="member-welcome-text">
              <p>Welcome, <strong>Ramesh Babu</strong></p>
              <span>Member ID: APNBM240520001</span>
            </div>
            <div className="member-avatar">R</div>
            
          </div>
        </div>
      </header>

      <div className="member-body">
        <aside className="member-sidebar" aria-label="Member navigation">
          <nav className="member-navigation">
            <NavItem to="/dashboard" icon={<FaHome />} label="Dashboard" />
            <NavItem to="/profile" icon={<FaUser />} label="My Profile" />
            <NavItem to="/membership-details" icon={<FaIdCard />} label="Membership Details" />
            <NavItem to="/payment-history" icon={<FaCreditCard />} label="Payment History" />
            <NavItem to="/id-card" icon={<FaAddressCard />} label="ID Card" />
            <NavItem to="/claims" icon={<FaClipboardCheck />} label="Claims"  />
            <NavItem to="/member-downloads" icon={<FaDownload />} label="Downloads" />
            <NavItem to="/notifications" icon={<FaBell />} label="Notifications" />
            <NavItem to="/support" icon={<FaHeadset />} label="Support" />
            <NavItem to="/refer-earn" icon={<FaUsers />} label="Refer & Earn" />
          </nav>

          <button type="button" className="sidebar-logout" onClick={handleLogout}>
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </aside>

        <main className="member-content">
          <Outlet />
        </main>
      </div>

      <footer className="member-footer">
        <span>
          © 2024 APNB Seva Samithi &amp; Vidya Charitable Trust. All Rights Reserved.
        </span>
        <div className="footer-links">
          <a href="#privacy">Privacy Policy</a>
          <span>|</span>
          <a href="#terms">Terms &amp; Conditions</a>
          <span>|</span>
          <a href="#refund">Refund Policy</a>
        </div>
      </footer>
    </div>
  );
}

function NavItem({ to, icon, label, badge }) {
  return (
    <NavLink
      to={to}
      title={label}
      className={({ isActive }) =>
        `member-nav-item ${isActive ? "active" : ""}`
      }
    >
      <span className="nav-icon">{icon}</span>
      <span className="nav-label">{label}</span>
      {badge && <span className="nav-badge">{badge}</span>}
    </NavLink>
  );
}

export default MemberLayout;
